

<div class="nav-under container-fluid header-borders border-bottom py-2">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb bg-white page-title">
      <li class="breadcrumb-item">App Usage</li>
      <li class="breadcrumb-item active" aria-current="page"><a id="user-category">Village agents</a></li>
    </ol>
  </nav>
</div>

<div class="row">
  <div class="col pl-4">
    <div class="nav nav-pills flex-column mt-2">
      <a class="nav-link active" data-toggle="tab" href="#villageagents" role="tab">Village Agents</a>
      <a class="nav-link" data-toggle="tab" href="#smartphoneusers" role="tab">Smart phone users</a>
      <a class="nav-link" data-toggle="tab" href="#saasusers" role="tab">Saas users</a>
      <a class="nav-link" data-toggle="tab" href="#agrishop" role="tab">Agrishop</a>
      <a class="nav-link" data-toggle="tab" href="#milkledger" role="tab">Milk ledger</a>
      <a class="nav-link" data-toggle="tab" href="#producemarket" role="tab">Produce market</a>
      <a class="nav-link" data-toggle="tab" href="#ezycredits" role="tab">EzyCredits</a>
      <a class="nav-link" data-toggle="tab" href="#revenue" role="tab">Revenue</a>
    </div>
  </div>
  <span class="border-right" style="height: 800px;"></span>
  <div class="col-md-10">
    <div class="tab-content container-fluid">
      <div id="villageagents" class="tab-pane show active" role="tabpanel">
        <app-village-agents>
        </app-village-agents>
      </div>
      <div id="smartphoneusers" class="tab-pane" role="tabpanel">
        Smart phone users
      </div>
      <div id="saasusers" class="tab-pane" role="tabpanel">
        Saas users
      </div>
      <div id="agrishop" class="tab-pane" role="tabpanel">
        AgriShop
      </div>
      <div id="milkledger" class="tab-pane" role="tabpanel">
        Milk Ledger
      </div>
      <div id="producemarket" class="tab-pane" role="tabpanel">
        Produce Market
      </div>
      <div id="ezycredits" class="tab-pane" role="tabpanel">
        Ezycredits
      </div>
      <div id="revenue" class="tab-pane" role="tabpanel">
        Revenue
      </div>
    </div>
  </div>
</div>
